import React from 'react';
import { useIntl } from 'react-intl';
import {toAbsoluteUrl} from '../../../../../_dashboard/helpers'
import { ImagePlacement, recommendedSizeFor } from '../../../../utils/imagePlacements'

interface ImageUploaderProps {
  image: { url: string; _id: string } | null; 
  handleImageClick: () => void;
  placement?: ImagePlacement | string;
  showSizeHint?: boolean;
}

const ImageUploader: React.FC<ImageUploaderProps> = ({
  image,
  handleImageClick,
  placement = 'slider',
  showSizeHint = true,
}) => {
  const intl = useIntl();
  const sizeLabel = recommendedSizeFor(placement);

  return (
    <div className='d-inline-flex flex-column align-items-start'>
      <div className='image-container-dashed'>
        <div className='image-container-placeholder' onClick={() => handleImageClick()}>
          <img src={toAbsoluteUrl('/media/icons/upload-image.png')} alt="uploadimage" />
          <span>{intl.formatMessage({ id: 'COMMON.ADD' })}</span>
        </div>
      </div>
      {showSizeHint && sizeLabel ? (
        <div className='form-text text-muted mt-2 mb-0'>
          {intl.formatMessage({ id: 'COMMON.IMAGE.RECOMMENDED_SIZE' }, { size: sizeLabel })}
        </div>
      ) : null}
    </div>
  );
};

export default ImageUploader;
